// 2P AI — card tratteggiata "Nuovo progetto/server" in coda alla griglia.
import { Icon } from './Icon';
import { onCardKey } from '../lib/a11y';

export function NewCard({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <div className="card new" role="button" tabIndex={0} onClick={onClick} onKeyDown={onCardKey(onClick)}>
      <div><Icon name="add_circle" /><span>{label}</span></div>
    </div>
  );
}
